import React from 'react'
import { Button } from 'components/ui'
import { useNavigate } from 'react-router-dom'
import { HiOutlineBan } from 'react-icons/hi'

const FeatureDisabled = ({
  featureName = 'This feature',
  description = 'This feature is currently disabled by the admin. Please contact your administrator if you need access.',
}) => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 p-8 text-center">
        <HiOutlineBan className="text-6xl mx-auto text-gray-400 mb-4" />
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          {featureName} is disabled
        </h1>
        <p className="text-gray-600 mb-6">{description}</p>
        <Button
          variant="solid"
          onClick={() => navigate('/manager-dashboard')}
          style={{ backgroundColor: '#042663' }}
          className="text-white"
        >
          Back to Dashboard
        </Button>
      </div>
    </div>
  )
}

export default FeatureDisabled
